import { combineReducers } from "@reduxjs/toolkit";
import user from "./features/user"
import app from "./features/app";
import registration from "./features/registration";
import persistedSignInAuth from "./features/persistedSignInAuth";
import currentBusiness from './features/currentBusiness'
import currentBusinessShop from './features/currentBusinessShop'
import cart from './features/cart'

const rootReducer = combineReducers({

    user,
    app,
    registration,
    persistedSignInAuth,
    currentBusiness,
    currentBusinessShop,
    cart

})

export default rootReducer